<mat-sidenav-container class="layout-container">
  <mat-sidenav mode="side" [(opened)]="opened" class="sidenav">
    <div class="logo">
      <img src="../../assets/icons/painel_logo_branca.png" alt="Logo" />
    </div>

    <mat-nav-list>
  @for (item of menu; track $index){
    @if(!item.hide){
    <a mat-list-item class="menu-row" routerLink="{{'/home'+item.route}}" routerLinkActive="active">
        <div class="mat-list-item-content">
          <mat-icon class="menu-icon">{{item.icon}}</mat-icon>
          <span class="menu-label">{{item.label}}</span>
        </div>
      </a>
     }
    }
    <a mat-list-item class="menu-row logout-btn" (click)="logout()" routerLinkActive="active">
       <div class="mat-list-item-content">
          <mat-icon class="menu-icon">logout</mat-icon>
          <span class="menu-label">Sair</span>
       </div>

    </a>
    </mat-nav-list>


  </mat-sidenav>

  <mat-sidenav-content>
    <mat-toolbar color="primary" class="header">
      <button mat-icon-button (click)="opened = !opened">
        <mat-icon>menu</mat-icon>
      </button>

      <span class="title">{{settingsService.title}}</span>
      <span class="spacer"></span>

    <!-- <button mat-icon-button>
        <mat-icon>notifications</mat-icon>
      </button>

      <button mat-icon-button>
        <mat-icon>account_circle</mat-icon>
      </button>-->
    </mat-toolbar>

    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
